// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  name: 'dev',
  production: false,
  region: 'NA',
  appUrl: 'https://asset-profile.dev.zonarsystems.net',

  apiBase: {
    nonProdUrl: 'https://zonar-nonprod-dev.apigee.net',
    url: 'https://api-dev.zonarsystems.net'
  },

  coreEntityApiBase: {
    url: 'https://api-dev.zonarsystems.net/core/v1'
  },

  userPreferenceApiBase: {
    url: 'https://api-dev.zonarsystems.net/alert/v1'
  },

  tripApiBase: {
    url: 'https://trip-api.dev.zonarsystems.net'
  },

  eventSubscriptionApiBase: {
    url: 'https://event-subscription-api.development.zonarsystems.net/v1'
  },

  locationApi: {
    assetPropertiesUrl: 'https://location-writer-db.dev.zonarsystems.net'
  },

  //  TODO: Setup your application's authentication variables: see
  //  https://gitlab.com/ZonarSystems/tools/pattern-library/-/tree/master/projects/zonar-ui-auth
  // for instructions on how to do that.
  authEnv: 'development',

  auth: {
    clientID: '2NFKscJG8jxrA69GM7i2gntuLecVo7iU',
    domain: 'zonar-dev.auth0.com',
    audience: 'http://apidev.zonarsystems.net/',
    // These come from the Core APIs as your application is built.
    applicationId: 'fdcb7e8f-cc75-4466-b07e-f1e21c8f51c0',
  },

  pendo: {
    url: 'https://cdn.pendo.io/agent/static/',
    key: '47e63a49-4477-47c2-4ea6-0f032e1785d5'
  },

  googleTagManager: {
    id: 'GTM-PM9R42P',
    auth: '',
    environment: ''
  },

  //TODO: Setup your application's datadog app
  datadog: {
    applicationId: '<DATADOG_APPLICATION_ID>',
    clientToken: '<DATADOG_CLIENT_TOKEN>',
    site: 'us5.datadoghq.com',
    tagEnvironment: 'dev'
  },

  i18n: {
    supportedLanguages: [
      'en-US',
      'de-DE',
      'en-GB',
      'it-IT',
      'fr-FR',
      'es-ES'
    ],
    defaultLanguage: 'en-US'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
